<template>
  <div class="d-flex flex-column">
    <div class="d-flex">
    <subnav class="flex-grow-1" v-if="subnav" :links="subnav" heading="Личный кабинет">
      <button class="btn btn-primary my-1 mr-1" style="min-width: 30px" :disabled="!canAddOrganization()" @click="addOrganization()">Добавить организацию</button>
    </subnav>
    </div>
    <div class="flex-grow-1 position-relative">
      <div class="overflow-content">
        <div class="pb-5">
          <transition name="fade" mode="out-in">
            <router-view @organizationCreated="onCreated" :organization_data="myProps"/>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  export default {
    metaInfo () {
      return {title: `Личный кабинет`}
    },
    data: () => ({
      organizations: [],
      new_organization: null,
    }),
    computed: {
      subnav () {
        let res = this.organizations.map((organization, index) => {
          return {
            text: index ? 'Организация №' + (index + 1) : 'Основная организация',
            to: `/personal/organization/${organization.id}`,
          }
        })
        res.unshift({
          text: 'Подписант',
          to: '/personal/signatory',
        })
        res.unshift({
          text: 'Общее',
          to: '/personal',
          exact: true,
        })
        if (this.new_organization) {
          res.push({
            text: 'Новая организация',
            to: `/personal/organization/create`,
          })
        }
        res.push({
          text: 'Смена пароля',
          to: '/personal/refresh',
        })
        return res
      },
      myProps () {
        if (this.$route.name === 'organization') {
          return this.organizations.find((el) => {
            return el.id === this.$route.params.id
          }).organization
        }
        if (this.$route.name === 'new_organization') {
          return this.new_organization
        }
        return {}
      },
    },
    asyncComputed: {
      subordinates () {
        api.get('divisions/subordinates')
          .then(({data}) => {
            this.organizations = data.data
          })
      },
    },
    methods: {
      canAddOrganization () {
        return this.organizations.length < 5 && !this.new_organization
      },
      addOrganization () {
        this.new_organization = {}
        this.$router.push('/personal/organization/create')
      },
      onCreated (organization) {
        this.organizations.push(organization)
        this.new_organization = null
        this.$router.push(`${organization.id}`)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/personal.vue